<div class="sisense-report-container">
	<iframe title="Automated Insights" id="sisenseReportIframe" [src]="sisenseReportIframeUrl | safe">
	</iframe>
</div>
